import * as React from 'react';
import { FC } from 'react';
import Field from './Field';
import { useContext } from './useFormContext';
import { UpdateValidationState } from './useValidationState';

const NetworkBadge: FC<{ vendorCurrency: string }> = ({ vendorCurrency }) => {
  const { locales, extra } = useContext();
  const network = extra.networks[vendorCurrency];

  if (!network) return null;

  return (
    <div
      className="rs-text-size_small alert"
      style={{ textAlign: 'center', border: '2px solid orange', padding: '0.5em 1em', marginBottom: '1em' }}
    >
      <div style={{ fontSize: '0.6rem' }}>{locales.network}</div>
      <div style={{ marginBottom: '-0.3rem', fontFamily: 'Arial' }}>
        <b>{network[0]}</b>
      </div>
      <div>{network[1]}</div>
    </div>
  );
};

const CryptoTarget: FC<{ updateValidationState: UpdateValidationState }> = ({ updateValidationState }) => {
  const { locales } = useContext();

  return (
    <Field
      label={locales.target_label}
      name="target"
      validation="required"
      updateValidationState={updateValidationState}
      placeholder={locales.target_placeholder}
    />
  );
};

const CryptoMemoTag: FC<{
  vendorCurrency: string;
  updateValidationState: UpdateValidationState;
}> = ({ vendorCurrency, updateValidationState }) => {
  const { extra } = useContext();

  if (!extra.payments_with_tag.includes(vendorCurrency)) return null;
  const tagValidation = extra.payments_with_optional_tag.includes(vendorCurrency) ? undefined : 'required';

  return (
    <Field
      key={`${vendorCurrency}-target_extra`}
      label="Memo (tag)"
      name="target_extra"
      validation={tagValidation}
      updateValidationState={updateValidationState}
    />
  );
};

const CryptoHint: FC = () => {
  const { locales } = useContext();

  return (
    <div className="rs-row">
      <div className="rs-column-small-12">
        <p className="rs-text-size_small">{locales.hint}</p>
      </div>
    </div>
  );
};

const CryptoWithdrawalDetails: FC<{
  vendorCurrency: string;
  updateValidationState: UpdateValidationState;
}> = ({ vendorCurrency, updateValidationState }) => (
  <>
    <NetworkBadge vendorCurrency={vendorCurrency} />
    <CryptoTarget updateValidationState={updateValidationState} />
    <CryptoMemoTag vendorCurrency={vendorCurrency} updateValidationState={updateValidationState} />
    <CryptoHint />
  </>
);

export default CryptoWithdrawalDetails;
